import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n'; // Initialize i18n before App renders
import App from './App';
import '@fontsource/exo-2';

// Wait for DOM to be ready and ensure root element exists
function initializeApp() {
  const rootElement = document.getElementById('root');
  
  if (!rootElement) {
    console.error('❌ CRITICAL: Root element not found!');
    console.error('Document ready state:', document.readyState);
    console.error('Document body:', document.body);
    console.error('Document HTML:', document.documentElement);
    
    // Try waiting a bit and retry
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeApp);
      return;
    }
    
    // If still not found, create it as fallback
    console.warn('⚠️ Creating root element as fallback');
    const newRoot = document.createElement('div');
    newRoot.id = 'root';
    document.body.appendChild(newRoot);
    const root = ReactDOM.createRoot(newRoot);
    root.render(<App />);
    return;
  }
  
  console.log('✅ Root element found, initializing React app');
  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeApp);
} else {
  // DOM is already ready
  initializeApp();
}
